import * as React from 'react';

import { NumericField, NumericFieldProps } from 'components/Form';
import { Omit } from 'types';
import SlideOptionsField from './SlideOptionsField';

type Props = Omit<NumericFieldProps, 'label'>;

const SlideAttributionXField: React.SFC<Props> = ({ className, ...props }) => (
  <SlideOptionsField className={className}>
    <NumericField {...props} label="Attribution X" />
  </SlideOptionsField>
);

export default SlideAttributionXField;
export { Props as SlideAttributionXFieldProps };
